/* don't quit — Relaunch 2026-10
   Reines JavaScript, keine Bibliothek, kein Netzaufruf, keine KI.
   Das Deck steht als JSON im Markup (<script type="application/json" id="dq-deck">). */

(function () {
  "use strict";

  var speicherSchluessel = "dq_spiel_v1";

  function lies(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function zufall(n) { return Math.floor(Math.random() * n); }

  function standLesen() {
    try { return JSON.parse(localStorage.getItem(speicherSchluessel) || "{}"); }
    catch (e) { return {}; }
  }

  function standSchreiben(s) {
    try { localStorage.setItem(speicherSchluessel, JSON.stringify(s)); } catch (e) { /* privater Modus */ }
  }

  /* ------------------------------------------------------------------
     Der Kartenzieher
     ------------------------------------------------------------------ */

  function kartenzieher(wurzel) {
    var deck = lies("dq-deck");
    if (!deck || !deck.challenges || !deck.challenges.length) return;

    var karte = wurzel.querySelector("[data-dq-karte]");
    var typEl = wurzel.querySelector("[data-dq-typ]");
    var titelEl = wurzel.querySelector("[data-dq-titel]");
    var stufeEl = wurzel.querySelector("[data-dq-stufe]");
    var muskelnEl = wurzel.querySelector("[data-dq-muskeln]");
    var noerglerEl = wurzel.querySelector("[data-dq-noergler]");
    var uhrEl = wurzel.querySelector("[data-dq-uhr]");
    var uhrfeldEl = wurzel.querySelector("[data-dq-uhrfeld]");
    var blitzEl = document.querySelector("[data-dq-blitz]");
    var lenaEl = wurzel.querySelector("[data-dq-lena]");
    var lenaRolle = wurzel.querySelector("[data-dq-lena-rolle]");
    var lenaText = wurzel.querySelector("[data-dq-lena-text]");
    var lenaQuelle = wurzel.querySelector("[data-dq-lena-quelle]");
    var zitate = lies("dq-zitate") || [];
    var lenaTexte = lies("dq-lena-texte") || {};
    var tagesEl = wurzel.querySelector("[data-dq-tagesuebung]");
    var paktFeld = wurzel.querySelector("[data-dq-paktfeld]");
    var paktWahl = wurzel.querySelector("[data-dq-paktwahl]");
    var paktKonto = wurzel.querySelector("[data-dq-paktkonto]");
    var paktBtn = wurzel.querySelector("[data-dq-pakt]");
    var arenaEl = document.querySelector("[data-dq-arena]");
    var spielEl = wurzel;
    var ausreden = lies("dq-noergler") || [];
    var figurEl = wurzel.querySelector("[data-dq-figur]");
    var schritte = lies("dq-schritte") || {};
    var uebungen = lies("dq-uebungen") || {};
    var anleitungEl = wurzel.querySelector("[data-dq-anleitung]");
    var grossfigurEl = wurzel.querySelector("[data-dq-grossfigur]");
    var phaseEl = wurzel.querySelector("[data-dq-phase]");
    var anlTitelEl = wurzel.querySelector("[data-dq-anleitung-titel]");
    var anlSchritteEl = wurzel.querySelector("[data-dq-schritte]");
    var anlFehlerEl = wurzel.querySelector("[data-dq-fehler]");
    var anlMehrEl = wurzel.querySelector("[data-dq-mehr]");
    var serieEl = wurzel.querySelector("[data-dq-serie]");
    var serieZahlEl = wurzel.querySelector("[data-dq-seriezahl]");
    var gespenstEl = wurzel.querySelector("[data-dq-gespenst]");
    var gespenstWertEl = wurzel.querySelector("[data-dq-gespenstwert]");
    var gespenstSatzEl = wurzel.querySelector("[data-dq-gespenstsatz]");
    var duellEl = wurzel.querySelector("[data-dq-duell]");
    var duellTextEl = wurzel.querySelector("[data-dq-duelltext]");
    var duellZahlEl = wurzel.querySelector("[data-dq-duellzahl]");
    var duellBtn = wurzel.querySelector("[data-dq-duellknopf]");
    var duellFeldEl = wurzel.querySelector("[data-dq-duellfeld]");
    var countdownEl = wurzel.querySelector("[data-dq-countdown]");
    var tippEl = wurzel.querySelector("[data-dq-tippen]");
    var tippZahlEl = wurzel.querySelector("[data-dq-tippzahl]");
    var bestwertEl = wurzel.querySelector("[data-dq-bestwert]");
    var ziehBtn = wurzel.querySelector("[data-dq-ziehen]");
    var startBtn = wurzel.querySelector("[data-dq-start]");
    var schaffBtn = wurzel.querySelector("[data-dq-geschafft]");
    var ausBtn = wurzel.querySelector("[data-dq-raus]");
    var actionBtn = wurzel.querySelector("[data-dq-action]");
    var geschafftEl = wurzel.querySelector("[data-dq-zaehler-geschafft]");
    var gezogenEl = wurzel.querySelector("[data-dq-zaehler-gezogen]");
    var ausgangEl = wurzel.querySelector("[data-dq-ausgang]");
    var stufenWahl = wurzel.querySelectorAll("[data-dq-level]");

    var stand = standLesen();
    var stufe = typeof stand.stufe === "number" ? stand.stufe : 1;
    var offeneKarte = null;
    var takt = null;
    var reihe = [];
    var tipps = 0;
    var istZeitKarte = false;

    stand.beste = stand.beste || {};
    stand.pakte = stand.pakte || { geschlossen: 0, gehalten: 0 };
    var paktZiel = null;

    function zaehlerZeigen() {
      if (geschafftEl) geschafftEl.textContent = stand.geschafft || 0;
      if (gezogenEl) gezogenEl.textContent = stand.gezogen || 0;
    }

    function stufeZeigen() {
      Array.prototype.forEach.call(stufenWahl, function (b) {
        b.setAttribute("aria-pressed", String(Number(b.dataset.dqLevel) === stufe));
      });
    }

    function naechsteChallenge() {
      if (!reihe.length) {
        reihe = deck.challenges.map(function (_, i) { return i; });
        for (var i = reihe.length - 1; i > 0; i--) {
          var j = zufall(i + 1);
          var t = reihe[i]; reihe[i] = reihe[j]; reihe[j] = t;
        }
      }
      return deck.challenges[reihe.pop()];
    }

    function knoepfe(zustand) {
      if (typeof figurTempo === "function") figurTempo(zustand === "laeuft");
      if (ziehBtn) ziehBtn.hidden = zustand !== "leer";
      // Der Pakt ist freiwillig: wer nichts waehlt, spielt den Kartenwert.
      // Vorher hing der Start-Knopf am Pakt, dadurch sah die gezogene Karte
      // aus wie eine Sackgasse.
      if (startBtn) startBtn.hidden = zustand !== "gezogen";
      if (paktBtn) paktBtn.hidden = true;
      if (paktFeld) paktFeld.hidden = zustand !== "gezogen";
      if (schaffBtn) schaffBtn.hidden = !(zustand === "laeuft" || zustand === "fertig");
      if (ausBtn) ausBtn.hidden = !(zustand === "laeuft" || zustand === "fertig");
      if (actionBtn) actionBtn.hidden = zustand !== "gezogen";
      if (tippEl) tippEl.hidden = !(!istZeitKarte && (zustand === "laeuft" || zustand === "fertig"));
    }

    var startSek = 0;
    var restSek = 0;

    function uhrSetzen(sek, knapp) {
      if (!uhrEl || !uhrfeldEl) return;
      uhrfeldEl.hidden = sek === null;
      uhrfeldEl.dataset.knapp = knapp ? "true" : "false";
      uhrEl.dataset.aus = knapp ? "true" : "false";
      if (sek === null) { uhrEl.textContent = ""; return; }
      uhrfeldEl.style.setProperty("--anteil", startSek ? sek / startSek : 1);
      var m = Math.floor(sek / 60), s = sek % 60;
      uhrEl.textContent = m + ":" + String(s).padStart(2, "0");
    }

    function zahlHeben(el) {
      if (!el) return;
      el.dataset.hoch = "true";
      setTimeout(function () { el.dataset.hoch = "false"; }, 190);
    }

    function bestwertZeigen(c) {
      if (!bestwertEl) return;
      var b = c && stand.beste[c.titel + "|" + stufe];
      if (!b) { bestwertEl.hidden = true; return; }
      bestwertEl.hidden = false;
      bestwertEl.textContent = "Dein Bestwert bei " + c.titel + ", Stufe " + (stufe + 1) + ": " +
        (b.art === "zeit" ? b.wert + " Sekunden durchgehalten" : b.wert + " Wiederholungen");
    }

    // Zwei Geraete, ein Spiel - ohne Server. Die Karte, die Stufe und ein
    // Startzeitpunkt stehen in der Adresse. Beide Seiten kennen dieselbe
    // Uhrzeit, also laufen beide Zaehler synchron. Kein Konto, keine
    // Datenbank, keine laufenden Kosten.
    var DUELL_VORLAUF = 20000;

    function duellLinkBauen() {
      if (!offeneKarte || offeneKarte.art !== "challenge") return "";
      var nr = deck.challenges.indexOf(offeneKarte.daten);
      if (nr < 0) return "";
      var paket = { k: nr, s: stufe, t: Date.now() + DUELL_VORLAUF };
      var code = btoa(JSON.stringify(paket)).replace(/=+$/, "");
      return location.origin + location.pathname + "?duell=" + code + "#karte-ziehen";
    }

    function duellLesen() {
      var treffer = /[?&]duell=([A-Za-z0-9+/]+)/.exec(location.search);
      if (!treffer) return null;
      try {
        var roh = atob(treffer[1] + "===".slice((treffer[1].length + 3) % 4));
        var d = JSON.parse(roh);
        if (typeof d.k !== "number" || typeof d.t !== "number") return null;
        if (!deck.challenges[d.k]) return null;
        return d;
      } catch (e) { return null; }
    }

    // Beim Oeffnen eines Duell-Links: dieselbe Karte, derselbe Countdown.
    function duellStarten() {
      var d = duellLesen();
      if (!d || !duellEl) return;
      var rest = d.t - Date.now();
      duellEl.hidden = false;
      if (rest < -120000) {
        // Zwei Minuten nach dem Start ist das Duell vorbei.
        duellTextEl.textContent = "Dieses Duell ist gelaufen. Zieh dir eine eigene Karte.";
        duellEl.dataset.dqZustand = "vorbei";
        return;
      }
      stufe = Math.max(0, Math.min(3, d.s || 0));
      stand.stufe = stufe;
      stufeZeigen();
      zeigeChallenge(deck.challenges[d.k]);
      duellEl.dataset.dqZustand = "wartet";
      duellTextEl.textContent = rest > 0
        ? "Gleichzeitig mit dem anderen. Start in …"
        : "Der andere ist schon dabei. Los.";

      // setInterval statt requestAnimationFrame: ein Hintergrund-Tab haelt
      // Animationsbilder an, Intervalle laufen gedrosselt weiter. Die
      // Restzeit kommt ohnehin aus der Uhr, der Takt bleibt also synchron,
      // auch wenn jemand zwischendurch die App wechselt.
      var duellTakt = setInterval(function () {
        var uebrig = d.t - Date.now();
        if (uebrig > 0) {
          duellZahlEl.textContent = Math.ceil(uebrig / 1000);
          return;
        }
        clearInterval(duellTakt);
        duellZahlEl.textContent = "";
        duellEl.dataset.dqZustand = "laeuft";
        duellTextEl.textContent = "Ihr lauft gleichzeitig.";
        // Direkt die Runde starten statt den Knopf zu klicken: der kann in
        // diesem Moment noch verborgen sein, und der Takt laeuft nur einmal.
        runde();
      }, 200);
      duellZahlEl.textContent = Math.max(0, Math.ceil((d.t - Date.now()) / 1000));
    }

    // Das Gespenst: dein letzter Versuch auf derselben Karte und Stufe.
    // Nicht der Bestwert - der ist unerreichbar schoen. Der letzte Versuch
    // ist der, den man gerade schlagen kann.
    function versuchMerken(c, art, wert, geschafft) {
      if (!c) return;
      stand.letzte = stand.letzte || {};
      stand.letzte[c.titel + "|" + stufe] = {
        art: art, wert: wert, geschafft: !!geschafft, datum: heute()
      };
      standSchreiben(stand);
    }

    function letzterVersuch(c) {
      if (!c || !stand.letzte) return null;
      return stand.letzte[c.titel + "|" + stufe] || null;
    }

    // Balken mit zwei Spuren: oben du, darunter blass dein letzter Versuch.
    function gespenstZeigen(c) {
      if (!gespenstEl) return;
      var v = letzterVersuch(c);
      if (!v || !v.wert) { gespenstEl.hidden = true; return; }
      gespenstEl.hidden = false;
      gespenstEl.dataset.dqArt = v.art;
      gespenstWertEl.textContent = v.art === "zeit"
        ? v.wert + " Sekunden"
        : v.wert + " Wiederholungen";
      gespenstSatzEl.textContent = v.geschafft
        ? "Letztes Mal durchgezogen. Noch mal."
        : "Hier hast du letztes Mal aufgegeben.";
      gespenstEl.style.setProperty("--dq-ich", 0);
      gespenstEl.removeAttribute("data-dq-vorn");
      gespenstEl.removeAttribute("data-dq-ueberholt");
    }

    // Waehrend der Runde: eigener Balken waechst, beim Ueberholen ein Signal.
    function gespenstStand(eigenerWert) {
      if (!gespenstEl || gespenstEl.hidden) return;
      var v = letzterVersuch(offeneKarte && offeneKarte.daten);
      if (!v || !v.wert) return;
      var anteil = Math.max(0, Math.min(1.3, eigenerWert / v.wert));
      gespenstEl.style.setProperty("--dq-ich", anteil);
      if (eigenerWert > v.wert && !gespenstEl.dataset.dqUeberholt) {
        gespenstEl.dataset.dqUeberholt = "true";
        gespenstEl.dataset.dqVorn = "true";
        gespenstSatzEl.textContent = v.geschafft
          ? "Besser als letztes Mal."
          : "Weiter als letztes Mal. Ab hier ist alles neu.";
        DQ_TON.gong();
      }
    }

    function gespenstAus() {
      if (gespenstEl) gespenstEl.hidden = true;
    }

    function bestwertMerken(c, art, wert) {
      if (!c || !wert) return;
      var k = c.titel + "|" + stufe;
      var alt = stand.beste[k];
      if (!alt || wert > alt.wert) {
        stand.beste[k] = { art: art, wert: wert };
        standSchreiben(stand);
        return true;
      }
      return false;
    }

    /* Lena fuehrt durch das Spiel. Sie hat fuer jeden Zustand mehrere Saetze,
       damit sie sich nicht wiederholt, und eine Pose, die das Bild bewegt. */
    var letzterSatz = "";

    function satzAus(liste) {
      if (!liste || !liste.length) return "";
      if (liste.length === 1) return liste[0];
      var s;
      do { s = liste[zufall(liste.length)]; } while (s === letzterSatz);
      letzterSatz = s;
      return s;
    }

    function fuellen(vorlage, karte) {
      if (!karte) return vorlage;
      return vorlage
        .replace(/\{\{uebung\}\}/g, karte.original || karte.titel)
        .replace(/\{\{stufe\}\}/g, stufe + 1)
        .replace(/\{\{stufe_text\}\}/g, karte.stufen[stufe]);
    }

    function lenaZeigt(zustand, karte, zusatz) {
      if (!lenaEl || !lenaText) return;
      var z = lenaTexte[zustand];
      if (!z) return;
      lenaEl.hidden = false;
      var haltung = z.pose || "ruhig";
      lenaEl.dataset.dqPose = haltung;
      // Spott hat kein eigenes Bild; dafuer bleibt die ruhige Haltung stehen.
      var bild = haltung === "spottet" ? "ruhig" : haltung;
      lenaEl.querySelectorAll(".dq-lena__pose").forEach(function (p) {
        if (p.dataset.dqPose === bild) p.dataset.dqAktiv = "true";
        else p.removeAttribute("data-dq-aktiv");
      });
      lenaEl.dataset.dqStimmung =
        z.pose === "jubelt" ? "lob" : z.pose === "spottet" ? "spott" : "ruhig";
      lenaRolle.textContent = z.rolle || "Lena";
      if (lenaQuelle) { lenaQuelle.hidden = true; lenaQuelle.textContent = ""; }

      if (zusatz && zusatz.text) {
        lenaText.textContent = zusatz.text;
        if (zusatz.quelle && lenaQuelle) {
          lenaQuelle.hidden = false;
          lenaQuelle.textContent = zusatz.quelle;
        }
      } else {
        lenaText.textContent = fuellen(satzAus(z.saetze), karte);
      }

      lenaText.dataset.dqNeu = "false";
      void lenaText.offsetWidth;
      lenaText.dataset.dqNeu = "true";
    }

    /* Tagesuebung: eine Karte pro Tag zaehlt. Der Tag bestimmt, welche. */
    function heute() { return new Date().toISOString().slice(0, 10); }

    function tagesKarte() {
      var d = heute(), h = 0;
      for (var i = 0; i < d.length; i++) h = (h * 31 + d.charCodeAt(i)) >>> 0;
      return deck.challenges[h % deck.challenges.length];
    }

    function tagesStandZeigen() {
      if (!tagesEl) return;
      var erledigt = stand.tagLetzte === heute();
      tagesEl.hidden = false;
      tagesEl.dataset.dqErledigt = erledigt ? "true" : "false";
      tagesEl.innerHTML = erledigt
        ? "<strong>Tagesübung erledigt.</strong> " + (stand.tagStreak || 1) +
          (stand.tagStreak === 1 ? " Tag" : " Tage") + " in Folge. Morgen liegt die nächste hier."
        : "<strong>Deine Übung für heute:</strong> " + (tagesKarte().original || tagesKarte().titel) +
          ". Schaffst du sie, bekommst du ein Zitat dafür.";
    }

    function tagErledigt(karte) {
      if (!karte || karte.titel !== tagesKarte().titel) return false;
      if (stand.tagLetzte === heute()) return false;
      var gestern = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
      stand.tagStreak = stand.tagLetzte === gestern ? (stand.tagStreak || 0) + 1 : 1;
      stand.tagLetzte = heute();
      standSchreiben(stand);
      return true;
    }

    /* Der Pakt: Du sagst vorher an, wie weit du gehst. Haeltst du ihn nicht,
       hebt der Noergler den Beleg auf und zeigt ihn beim naechsten Besuch. */
    function paktStufen(karte) {
      var text = karte.stufen[stufe];
      var m = /(\d+)/.exec(text);
      var ziel = m ? parseInt(m[1], 10) : 0;
      var zeit = /Sekunden/.test(text);
      return [
        { wert: ziel, label: ziel + (zeit ? " s" : "x"), art: "soll" },
        { wert: Math.round(ziel * 1.5), label: Math.round(ziel * 1.5) + (zeit ? " s" : "x"), art: "mehr" },
        { wert: Math.round(ziel * 2), label: "doppelt", art: "doppelt" }
      ];
    }

    function paktZeigen(karte) {
      if (!paktFeld || !paktWahl) return;
      paktFeld.hidden = false;
      paktWahl.innerHTML = "";
      paktZiel = null;
      paktStufen(karte).forEach(function (p) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "dq-pakt";
        b.textContent = p.label;
        b.setAttribute("aria-pressed", "false");
        b.addEventListener("click", function () {
          Array.prototype.forEach.call(paktWahl.children, function (x) {
            x.setAttribute("aria-pressed", "false");
          });
          b.setAttribute("aria-pressed", "true");
          paktZiel = p;
          if (startBtn) startBtn.hidden = false;
        });
        paktWahl.appendChild(b);
      });
      paktKontoZeigen();
    }

    function paktKontoZeigen() {
      if (!paktKonto) return;
      var g = stand.pakte.geschlossen, h = stand.pakte.gehalten;
      paktKonto.innerHTML = g
        ? "Du hast <b>" + g + "</b> " + (g === 1 ? "Pakt" : "Pakte") +
          " geschlossen und <b>" + h + "</b> gehalten."
        : "Noch kein Pakt. Lena merkt sich beides.";
    }

    function paktOffen() {
      if (!stand.paktOffen) return null;
      var p = stand.paktOffen;
      stand.paktOffen = null;
      standSchreiben(stand);
      return p;
    }

    /* Die Arena: waehrend der Runde verschwindet der Rest der Seite. */
    function arena(an, knapp) {
      if (!arenaEl) return;
      arenaEl.hidden = false;
      arenaEl.dataset.dqAn = an ? "true" : "false";
      arenaEl.dataset.dqKnapp = knapp ? "true" : "false";
      spielEl.dataset.dqArena = an ? "true" : "false";
      if (!an) setTimeout(function () { if (arenaEl.dataset.dqAn !== "true") arenaEl.hidden = true; }, 500);
    }

    function blitzen() {
      if (!blitzEl) return;
      blitzEl.dataset.an = "true";
      setTimeout(function () { blitzEl.dataset.an = "false"; }, 650);
    }

    function stoppen() {
      if (takt) { clearInterval(takt); takt = null; }
    }

    // Wie viele Wiederholungen verlangt die offene Karte? Null bei
    // Zeitkarten - dort fuellt die Uhr den Ring.
    function zielWiederholungen() {
      if (!offeneKarte || offeneKarte.art !== "challenge") return 0;
      var text = offeneKarte.daten.stufen[stufe] || "";
      if (!/Wiederholung/i.test(text)) return 0;
      var n = parseInt(text, 10);
      return isNaN(n) ? 0 : n;
    }

    // Der Ring um die Figur fuellt sich mit der Runde. Ein Wert von 0 bis 1.
    function ringSetzen(anteil) {
      if (!grossfigurEl) return;
      grossfigurEl.style.setProperty("--dq-ring", Math.max(0, Math.min(1, anteil || 0)));
    }

    // Serie: wie viele Runden am Stueck durchgezogen wurden. Bricht beim
    // ersten Aufgeben. Liegt im Browser, kein Konto.
    function serieFuehren(geschafft) {
      if (geschafft) {
        stand.serie = (stand.serie || 0) + 1;
        if ((stand.serieBeste || 0) < stand.serie) stand.serieBeste = stand.serie;
      } else {
        stand.serie = 0;
      }
      standSchreiben(stand);
      serieZeigen(geschafft);
    }

    function serieZeigen(gerade) {
      if (!serieEl) return;
      var n = stand.serie || 0;
      if (n < 2) { serieEl.hidden = true; return; }
      serieEl.hidden = false;
      serieEl.dataset.dqStufe = n >= 5 ? "hoch" : n >= 3 ? "mittel" : "start";
      serieZahlEl.textContent = n;
      if (gerade) {
        serieEl.dataset.dqNeu = "true";
        setTimeout(function () { serieEl.removeAttribute("data-dq-neu"); }, 900);
      }
    }

    // Die Anleitung erklaert die Uebung vollstaendig: die Figur laeuft als
    // Bewegung durch, daneben laufen die fuenf Ausfuehrungsschritte im
    // selben Takt mit. Texte von den 20 Uebungsseiten des Shops.
    var anlTakt = null;

    function anleitungZeigen(karte) {
      if (!anleitungEl) return;
      if (anlTakt) { clearInterval(anlTakt); anlTakt = null; }
      var original = karte.original || karte.titel;
      var daten = uebungen[original];
      var bilder = schritte[original] || [];
      if (!daten || !daten.schritte || !daten.schritte.length) {
        anleitungEl.hidden = true;
        return;
      }
      anleitungEl.hidden = false;
      // Kein "So geht Liegestuetze" - der Name steht fuer sich.
      anlTitelEl.textContent = "So geht\u2019s: " + (karte.titel || original);

      // Figur gross, als Bewegung
      grossfigurEl.innerHTML = "";
      grossfigurEl.dataset.dqPhasen = String(bilder.length);
      bilder.forEach(function (datei, i) {
        var img = document.createElement("img");
        img.className = "dq-anleitung__bild";
        img.src = /^(https?:)?\//.test(datei) ? datei : "bilder/schritte/" + datei;
        img.alt = "";
        img.decoding = "async";
        if (i === 0) img.dataset.dqAktiv = "true";
        grossfigurEl.appendChild(img);
      });

      // Schritte als Liste
      anlSchritteEl.innerHTML = "";
      daten.schritte.forEach(function (s) {
        var li = document.createElement("li");
        li.textContent = s;
        anlSchritteEl.appendChild(li);
      });

      var f = (daten.fehler || [])[0];
      if (f) {
        anlFehlerEl.hidden = false;
        anlFehlerEl.innerHTML = "";
        var b = document.createElement("b");
        b.textContent = "Häufigster Fehler: " + f.fehler + ". ";
        anlFehlerEl.appendChild(b);
        anlFehlerEl.appendChild(document.createTextNode(f.richtig));
      } else {
        anlFehlerEl.hidden = true;
      }

      if (anlMehrEl && daten.seite) {
        anlMehrEl.href = daten.seite;
        anlMehrEl.textContent = (karte.titel || original) + " ganz ansehen";
      }

      // Takt: Bild und hervorgehobener Schritt laufen gemeinsam
      var bildEls = grossfigurEl.querySelectorAll(".dq-anleitung__bild");
      var zeilen = anlSchritteEl.querySelectorAll("li");
      var i = 0;
      function weiter() {
        if (bildEls.length > 1) {
          Array.prototype.forEach.call(bildEls, function (el) { el.removeAttribute("data-dq-aktiv"); });
          bildEls[i % bildEls.length].dataset.dqAktiv = "true";
        }
        Array.prototype.forEach.call(zeilen, function (el) { el.removeAttribute("data-dq-aktiv"); });
        if (zeilen[i % zeilen.length]) zeilen[i % zeilen.length].dataset.dqAktiv = "true";
        if (phaseEl) {
          phaseEl.textContent = bildEls.length > 1
            ? "Schritt " + String.fromCharCode(65 + (i % bildEls.length)) + " von " + bildEls.length
            : "Position halten";
        }
        i++;
      }
      weiter();
      anlTakt = setInterval(weiter, 1700);
    }

    function anleitungAus() {
      if (anlTakt) { clearInterval(anlTakt); anlTakt = null; }
      if (anleitungEl) anleitungEl.hidden = true;
    }

    // Die Schrittgrafiken stammen von den gedruckten Karten. Sie laufen im
    // Takt durch, damit man sieht, wie die Uebung ausgefuehrt wird.
    var figurTakt = null;

    function figurZeigen(original) {
      if (!figurEl) return;
      if (figurTakt) { clearInterval(figurTakt); figurTakt = null; }
      var liste = schritte[original] || [];
      figurEl.innerHTML = "";
      figurEl.hidden = liste.length === 0;
      if (!liste.length) return;
      liste.forEach(function (datei, i) {
        var img = document.createElement("img");
        img.className = "dq-karte__schritt";
        // Im Theme steht hier bereits die fertige asset_url, im Prototyp
        // nur der Dateiname.
        img.src = /^(https?:)?\//.test(datei) ? datei : "bilder/schritte/" + datei;
        img.alt = "";
        // Kein lazy: die Bilder entstehen erst beim Ziehen und sind dann sofort
        // im Blick.
        img.decoding = "async";
        if (i === 0) img.dataset.dqAktiv = "true";
        figurEl.appendChild(img);
      });
      if (liste.length < 2) return;
      var i = 0;
      var bilder = figurEl.querySelectorAll(".dq-karte__schritt");
      figurTakt = setInterval(function () {
        bilder[i].removeAttribute("data-dq-aktiv");
        i = (i + 1) % bilder.length;
        bilder[i].dataset.dqAktiv = "true";
      }, figurEl.dataset.dqSchnell === "true" ? 460 : 1000);
    }

    // Waehrend der Runde schlaegt die Figur im Arbeitstakt.
    function figurTempo(schnell) {
      if (!figurEl || !figurEl.firstChild) return;
      if (figurEl.dataset.dqSchnell === String(!!schnell)) return;
      figurEl.dataset.dqSchnell = String(!!schnell);
      var name = figurEl.dataset.dqKarte;
      if (name) figurZeigen(name);
    }

    function zeigeChallenge(c) {
      offeneKarte = { art: "challenge", daten: c };
      karte.classList.remove("dq-karte--action");
      typEl.textContent = "Challenge · Stufe " + (stufe + 1);
      titelEl.textContent = c.original || c.titel;
      stufeEl.textContent = c.stufen[stufe];
      if (figurEl) figurEl.dataset.dqKarte = c.original || c.titel;
      figurZeigen(c.original || c.titel);
      anleitungZeigen(c);
      // Bei SUPERMAN heisst die Uebung wie ihr Muskel ("Rueckenstrecker") -
      // dann nicht zweimal nennen.
      muskelnEl.textContent = c.muskeln.indexOf(c.titel) === 0 ? c.muskeln : c.titel + " · " + c.muskeln;
      muskelnEl.hidden = false;
      noerglerEl.textContent = "„" + c.noergler + "“";
      karte.dataset.offen = "true";
      karte.dataset.gegeben = "true";
      DQ_TON.karte();
      setTimeout(function () { karte.dataset.gegeben = "false"; }, 520);
      stand.gezogen = (stand.gezogen || 0) + 1;
      standSchreiben(stand);
      zahlHeben(gezogenEl);
      zaehlerZeigen();
      bestwertZeigen(c);
      gespenstZeigen(c);
      if (duellBtn) duellBtn.hidden = false;
      lenaZeigt(c.titel === tagesKarte().titel ? "tagesuebung" : "gezogen", c);
      knoepfe("gezogen");
      paktZeigen(c);
      uhrSetzen(null, false);
      if (ausgangEl) ausgangEl.hidden = true;
    }

    function zeigeAction() {
      var a = deck.actions[zufall(deck.actions.length)];
      offeneKarte = { art: "action", daten: a };
      karte.classList.add("dq-karte--action");
      typEl.textContent = "Action-Karte";
      titelEl.textContent = a.titel;
      stufeEl.textContent = a.text;
      if (figurEl) { figurEl.innerHTML = ""; figurEl.hidden = true; delete figurEl.dataset.dqKarte; }
      if (figurTakt) { clearInterval(figurTakt); figurTakt = null; }
      anleitungAus();
      muskelnEl.textContent = a.deutsch || "";
      muskelnEl.hidden = !a.deutsch;
      noerglerEl.textContent = "Im Spiel drehen diese Karten eine Runde komplett.";
      knoepfe("gezogen");
    }

    function sekundenAusText(text) {
      var m = /(\d+)\s*Sekunden/.exec(text);
      if (m) return parseInt(m[1], 10);
      return 45; /* Wiederholungen: feste Rundenzeit */
    }

    function countdown(fertig) {
      if (!countdownEl) { fertig(); return; }
      var n = 3;
      countdownEl.hidden = false;
      countdownEl.innerHTML = "<span>" + n + "</span>";
      var t = setInterval(function () {
        n--;
        if (n > 0) {
          countdownEl.innerHTML = "<span>" + n + "</span>";
        } else {
          clearInterval(t);
          countdownEl.innerHTML = "<span>LOS</span>";
          setTimeout(function () { countdownEl.hidden = true; countdownEl.textContent = ""; fertig(); }, 600);
        }
      }, 800);
    }

    function runde() {
      if (!offeneKarte || offeneKarte.art !== "challenge") return;
      /* Waehrend des Countdowns bleibt kein Knopf klickbar - sonst tauscht
         eine Action-Karte die offene Karte aus, bevor die Runde startet. */
      knoepfe("laeuft");
      countdown(rundeStarten);
    }

    function rundeStarten() {
      /* Die Karte kann waehrend des Countdowns gewechselt haben. */
      if (!offeneKarte || offeneKarte.art !== "challenge" || !offeneKarte.daten.stufen) {
        knoepfe("gezogen");
        return;
      }
      var text = offeneKarte.daten.stufen[stufe];
      istZeitKarte = /Sekunden/.test(text);
      tipps = 0;
      if (tippZahlEl) tippZahlEl.textContent = "0";
      var sek = sekundenAusText(text);
      startSek = sek;
      knoepfe("laeuft");
      uhrSetzen(sek, false);
      stoppen();
      restSek = sek;
      arena(true, false);
      if (paktZiel && offeneKarte) {
        stand.pakte.geschlossen++;
        stand.paktOffen = {
          karte: offeneKarte.daten.original || offeneKarte.daten.titel,
          ziel: paktZiel.label,
          art: paktZiel.art,
          datum: heute()
        };
        standSchreiben(stand);
      }
      lenaZeigt("laeuft", offeneKarte.daten);
      DQ_TON.musikAn();
      // Lena zaehlt sichtbar mit und der Ring um die Figur fuellt sich.
      if (lenaEl) lenaEl.dataset.dqZaehlt = "true";
      ringSetzen(0);
      takt = setInterval(function () {
        sek--;
        restSek = sek;
        if (sek === 10) { lenaZeigt("knapp", offeneKarte && offeneKarte.daten); arena(true, true); }
        // Das letzte Drittel tickt mit, die letzten fuenf Sekunden schaerfer.
        if (sek > 0 && sek <= 10) { if (sek <= 5) DQ_TON.letzte(); else DQ_TON.tick(); }
        if (lenaEl) {
          lenaEl.dataset.dqSchlag = lenaEl.dataset.dqSchlag === "a" ? "b" : "a";
          lenaEl.dataset.dqEng = sek <= 5 ? "true" : "false";
        }
        // Bei Wiederholungskarten zaehlt der Ring die Tipps, nicht die Zeit.
        if (!zielWiederholungen()) {
          ringSetzen(startSek ? (startSek - Math.max(sek, 0)) / startSek : 0);
          gespenstStand(startSek - Math.max(sek, 0));
        }
        uhrSetzen(Math.max(sek, 0), sek <= 5);
        if (sek <= 0) { stoppen(); DQ_TON.gong(); knoepfe("fertig"); }
      }, 1000);
    }

    /* Nach einer gespielten Karte fehlt sonst der Weg zum echten Spiel:
       Der Besucher hat gerade erlebt, wie sich eine Challenge anfuehlt, und
       steht danach ohne Angebot da. Der Hinweis bleibt dezent, der
       Kartenzieher bleibt kostenlos. */
    function bruecke() {
      var preisEl = document.querySelector(".dq-leiste__preis, .dq-preis__neu");
      var preis = preisEl ? (preisEl.textContent.match(/[\d.,]+\s*€|€\s*[\d.,]+/) || [""])[0].trim() : "";
      return '<a class="dq-knopf dq-knopf--lime dq-ausgang__kauf" href="#kaufen">' +
             'Mit 70 echten Karten gegeneinander spielen' +
             (preis ? ' \u00b7 ' + preis : '') +
             '</a>';
    }

    function abschluss(geschafft) {
      stoppen();
      if (lenaEl) {
        lenaEl.removeAttribute("data-dq-zaehlt");
        lenaEl.removeAttribute("data-dq-eng");
      }
      ringSetzen(geschafft ? 1 : 0);
      serieFuehren(geschafft);
      DQ_TON.musikAus();
      if (geschafft) DQ_TON.gong(); else DQ_TON.knick();
      arena(false, false);
      var pakt = paktOffen();
      if (pakt) {
        if (geschafft) {
          stand.pakte.gehalten++;
          stand.beleg = null;
        } else {
          stand.beleg = pakt;
        }
        standSchreiben(stand);
      }
      paktZiel = null;
      if (paktFeld) paktFeld.hidden = true;
      var c = offeneKarte && offeneKarte.art === "challenge" ? offeneKarte.daten : null;
      var neuerBestwert = false;
      if (c) {
        if (istZeitKarte) {
          var gehalten = startSek - Math.max(restSek, 0);
          if (geschafft) gehalten = startSek;
          neuerBestwert = bestwertMerken(c, "zeit", gehalten);
          versuchMerken(c, "zeit", gehalten, geschafft);
        } else if (tipps > 0) {
          neuerBestwert = bestwertMerken(c, "wdh", tipps);
          versuchMerken(c, "wdh", tipps, geschafft);
        }
      }
      gespenstAus();
      uhrSetzen(null, false);
      if (geschafft) {
        stand.geschafft = (stand.geschafft || 0) + 1;
        blitzen();
        zahlHeben(geschafftEl);
      }
      standSchreiben(stand);
      zaehlerZeigen();
      karte.dataset.offen = "false";
      offeneKarte = null;
      knoepfe("leer");
      if (bestwertEl) bestwertZeigen(c);
      var tagGeschafft = geschafft && tagErledigt(c);
      if (!geschafft) {
        var satz = (c && c.noergler) ? c.noergler : "Niemand hätte es dir verübelt.";
        lenaZeigt("aufgegeben", c, { text: "\u201e" + satz + "\u201c", quelle: "Steht so auf der Karte." });
      } else if (tagGeschafft) {
        lenaZeigt("tagesuebung_geschafft", c);
      } else if (zitate.length) {
        var z = zitate[zufall(zitate.length)];
        lenaZeigt("geschafft_mit_zitat", c, {
          text: "\u201e" + z.de + "\u201c",
          // Liegt ein fremdsprachiges Original vor, ist der deutsche Satz unsere
          // Uebersetzung - das sagen wir dazu.
          quelle: z.person + (z.rolle ? ", " + z.rolle : "") + (z.quelle ? " \u00b7 " + z.quelle : "") +
            (z.original ? " \u00b7 übersetzt" : "")
        });
      } else {
        lenaZeigt("geschafft_ohne_zitat", c);
      }
      tagesStandZeigen();
      paktKontoZeigen();
      belegZeigen();
      if (ausgangEl) {
        ausgangEl.hidden = false;
        var satzAusgang = neuerBestwert
          ? "<strong>Neuer Bestwert.</strong> " +
            (istZeitKarte ? "So lange hast du diese Karte noch nie gehalten." : "So viele Wiederholungen hattest du hier noch nie.") +
            " Im Spiel zu sechst wirst du den nochmal brechen \u2014 weil fünf Leute mitzählen."
          : geschafft
            ? "<strong>Durchgezogen.</strong> Allein ist das machbar. Zu sechst, wenn drei zuschauen und mitzählen, ist es eine ganz andere Übung."
            : "<strong>Aufgegeben.</strong> Genau hier steigen die meisten aus — allein merkt es keiner. Im Spiel schon.";
        ausgangEl.innerHTML = satzAusgang + bruecke();
      }
    }

    if (ziehBtn) ziehBtn.addEventListener("click", function () {
      var c = naechsteChallenge();
      var ruhig = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (ruhig) { zeigeChallenge(c); return; }
      ziehBtn.disabled = true;
      karte.dataset.mischt = "true";
      setTimeout(function () {
        karte.dataset.mischt = "false";
        ziehBtn.disabled = false;
        zeigeChallenge(c);
      }, 620);
    });
    if (duellBtn) duellBtn.addEventListener("click", function () {
      var url = duellLinkBauen();
      if (!url) return;
      duellFeldEl.hidden = false;
      duellFeldEl.value = url;
      duellFeldEl.select();
      var fertig = function () {
        duellBtn.textContent = "Link kopiert — schick ihn weiter";
        setTimeout(function () { duellBtn.textContent = "Jemanden herausfordern"; }, 2600);
      };
      if (navigator.share) {
        navigator.share({ title: "don't quit — Duell", url: url }).then(fertig).catch(function () {});
        return;
      }
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(fertig).catch(function () {});
      else fertig();
    });

    if (actionBtn) actionBtn.addEventListener("click", zeigeAction);
    if (startBtn) startBtn.addEventListener("click", runde);
    if (tippEl) tippEl.addEventListener("click", function () {
      tipps++;
      if (tippZahlEl) tippZahlEl.textContent = tipps;
      // Jeder Tipp schlaegt sichtbar auf die Figur durch.
      if (grossfigurEl) {
        grossfigurEl.dataset.dqSchlag = "true";
        setTimeout(function () { grossfigurEl.removeAttribute("data-dq-schlag"); }, 170);
      }
      if (lenaEl) lenaEl.dataset.dqSchlag = lenaEl.dataset.dqSchlag === "a" ? "b" : "a";
      // Bei Wiederholungen laeuft keine Uhr - dann fuellt der Ring sich
      // ueber die Tipps, sonst bliebe er die ganze Runde leer.
      var ziel = zielWiederholungen();
      if (ziel) ringSetzen(tipps / ziel);
      gespenstStand(tipps);
      if (ziel && tipps >= ziel) { DQ_TON.gong(); } else { DQ_TON.tick(); }
    });

    if (schaffBtn) schaffBtn.addEventListener("click", function () { abschluss(true); });
    if (ausBtn) ausBtn.addEventListener("click", function () { abschluss(false); });

    Array.prototype.forEach.call(stufenWahl, function (b) {
      b.addEventListener("click", function () {
        stufe = Number(b.dataset.dqLevel);
        stand.stufe = stufe;
        standSchreiben(stand);
        stufeZeigen();
        if (offeneKarte && offeneKarte.art === "challenge") {
          typEl.textContent = "Challenge · Stufe " + (stufe + 1);
          stufeEl.textContent = offeneKarte.daten.stufen[stufe];
        }
      });
    });

    function belegZeigen() {
      var alt = wurzel.querySelector(".dq-beleg");
      if (alt) alt.remove();
      if (!stand.beleg) return;
      var p = document.createElement("p");
      p.className = "dq-beleg";
      var heuteDatum = heute();
      p.innerHTML = stand.beleg.datum === heuteDatum
        ? "<strong>Pakt gebrochen.</strong> Du wolltest " + stand.beleg.ziel + " bei " + stand.beleg.karte + ". Der Nörgler hat es notiert."
        : "<strong>Noch offen seit " + stand.beleg.datum + ".</strong> Du wolltest " + stand.beleg.ziel + " bei " + stand.beleg.karte + " und hast aufgegeben. Heute nochmal?";
      var tisch = wurzel.querySelector(".dq-tisch");
      if (tisch) tisch.appendChild(p);
    }

    zaehlerZeigen();
    stufeZeigen();
    // Eine laufende Serie begruesst den Wiederkehrenden sofort.
    serieZeigen(false);
    duellStarten();
    tagesStandZeigen();
    paktKontoZeigen();
    belegZeigen();
    lenaZeigt("leer");
    knoepfe("leer");
    uhrSetzen(null, false);
  }

  /* ------------------------------------------------------------------
     Video erst auf Klick laden
     ------------------------------------------------------------------ */

  function videofassade(knopf) {
    knopf.addEventListener("click", function () {
      var quelle = knopf.dataset.dqVideo;
      if (!quelle) return;
      var v = document.createElement("video");
      v.src = quelle;
      v.controls = true;
      v.playsInline = true;
      v.preload = "auto";
      v.setAttribute("aria-label", knopf.dataset.dqVideoLabel || "Video");
      knopf.innerHTML = "";
      knopf.appendChild(v);
      knopf.classList.add("dq-videofassade--an");
      v.play();
    }, { once: true });
  }

  /* ------------------------------------------------------------------
     Kaufleiste: erscheint, sobald der Hero durch ist
     ------------------------------------------------------------------ */

  function kaufleiste(leiste) {
    /* Die Leiste kommt erst, wenn der Besucher am ersten Kaufangebot vorbei
       ist: auf der Startseite hinter dem Hero, auf der Produktseite hinter
       dem echten Warenkorb-Knopf. Vorher konkurrierte sie im Hero mit
       "Karte ziehen" und doppelte auf der Produktseite den Kaufknopf. */
    var marke = document.querySelector("[data-dq-leiste-marke]") ||
      document.querySelector('form[action*="/cart/add"] [name="add"]');
    if (!marke || !("IntersectionObserver" in window)) { leiste.dataset.sichtbar = "true"; return; }
    new IntersectionObserver(function (eintraege) {
      var e = eintraege[0];
      leiste.dataset.sichtbar = !e.isIntersecting && e.boundingClientRect.top < 0 ? "true" : "false";
    }, { threshold: 0 }).observe(marke);
  }

  /* ------------------------------------------------------------------
     Ton — standardmäßig aus, nie Autoplay
     ------------------------------------------------------------------ */

  // Der Schalter steht standardmaessig auf aus. Erst ein Klick darauf legt
  // den AudioContext an - ohne Nutzergeste geht ohnehin kein Ton, und so
  // laedt auch niemand ungefragt eine Musikdatei.
  var DQ_TON = {
    an: false,
    ctx: null,
    musik: null,
    quelle: "",

    anlegen: function () {
      if (this.ctx) return this.ctx;
      var C = window.AudioContext || window.webkitAudioContext;
      if (!C) return null;
      this.ctx = new C();
      return this.ctx;
    },

    // Ein kurzer Ton, synthetisiert. Kostet keinen einzigen geladenen Byte.
    piep: function (hz, dauer, art, laut) {
      if (!this.an) return;
      var c = this.anlegen();
      if (!c) return;
      if (c.state === "suspended") c.resume();
      var o = c.createOscillator(), g = c.createGain();
      o.type = art || "sine";
      o.frequency.setValueAtTime(hz, c.currentTime);
      g.gain.setValueAtTime(0, c.currentTime);
      g.gain.linearRampToValueAtTime(laut == null ? 0.18 : laut, c.currentTime + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + dauer);
      o.connect(g); g.connect(c.destination);
      o.start(); o.stop(c.currentTime + dauer + 0.02);
    },

    karte:  function () { this.piep(190, 0.14, "triangle", 0.22); },
    tick:   function () { this.piep(1180, 0.045, "square", 0.08); },
    letzte: function () { this.piep(1480, 0.07, "square", 0.13); },
    gong:   function () { this.piep(392, 0.9, "sine", 0.3); this.piep(588, 0.75, "sine", 0.16); },
    knick:  function () { this.piep(120, 0.4, "sawtooth", 0.14); },

    // Musik laeuft nur waehrend einer Runde, nie im Leerlauf.
    musikAn: function () {
      if (!this.an || !this.quelle) return;
      if (!this.musik) {
        this.musik = new Audio(this.quelle);
        this.musik.loop = true;
        this.musik.volume = 0.3;
      }
      var v = this.musik.play();
      if (v && v.catch) v.catch(function () {});
    },
    musikAus: function () {
      if (!this.musik) return;
      this.musik.pause();
      this.musik.currentTime = 0;
    }
  };

  // Lenas Blick folgt dem Zeiger. Eine Verschiebung von wenigen Pixeln
  // reicht - mehr wirkt sofort albern. Nur auf Zeigegeraeten, nie auf
  // Beruehrung, und nie bei reduzierter Bewegung.
  function lenaBlick(lena) {
    if (!window.matchMedia) return;
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var figur = lena.querySelector(".dq-lena__figur");
    if (!figur) return;
    var zielX = 0, zielY = 0, istX = 0, istY = 0, laeuft = false;

    function schritt() {
      istX += (zielX - istX) * 0.12;
      istY += (zielY - istY) * 0.12;
      figur.style.setProperty("--dq-blick-x", istX.toFixed(2) + "px");
      figur.style.setProperty("--dq-blick-y", istY.toFixed(2) + "px");
      if (Math.abs(zielX - istX) > 0.05 || Math.abs(zielY - istY) > 0.05) {
        requestAnimationFrame(schritt);
      } else {
        laeuft = false;
      }
    }

    window.addEventListener("mousemove", function (e) {
      var k = figur.getBoundingClientRect();
      if (!k.width) return;
      var mx = e.clientX - (k.left + k.width / 2);
      var my = e.clientY - (k.top + k.height / 2);
      var weite = Math.max(window.innerWidth, 1);
      zielX = Math.max(-7, Math.min(7, (mx / weite) * 26));
      zielY = Math.max(-5, Math.min(5, (my / Math.max(window.innerHeight, 1)) * 18));
      if (!laeuft) { laeuft = true; requestAnimationFrame(schritt); }
    }, { passive: true });
  }

  function tonschalter(knopf) {
    DQ_TON.quelle = knopf.dataset.dqTonQuelle || "";
    knopf.setAttribute("aria-pressed", "false");
    knopf.addEventListener("click", function () {
      DQ_TON.an = !DQ_TON.an;
      knopf.setAttribute("aria-pressed", String(DQ_TON.an));
      if (DQ_TON.an) { DQ_TON.anlegen(); DQ_TON.karte(); }
      else DQ_TON.musikAus();
    });
  }

  /* ------------------------------------------------------------------
     Mengenwahl im Geschenkabschnitt
     ------------------------------------------------------------------ */

  function mengenwahl(gruppe) {
    var optionen = gruppe.querySelectorAll("[data-dq-menge]");
    var feld = document.querySelector("[data-dq-mengenfeld]");

    function waehlen(o) {
      Array.prototype.forEach.call(optionen, function (x) {
        x.setAttribute("aria-checked", "false");
        x.tabIndex = -1;
      });
      o.setAttribute("aria-checked", "true");
      o.tabIndex = 0;
      if (feld) feld.value = o.dataset.dqMenge;
    }

    Array.prototype.forEach.call(optionen, function (o, i) {
      if (o.getAttribute("aria-checked") !== "true") o.tabIndex = -1;
      o.addEventListener("click", function () { waehlen(o); });
      /* Die Optionen sind divs mit role="radio" - ohne diese Tasten waren sie
         per Tab erreichbar, aber nicht auswaehlbar. Verhalten wie eine echte
         Radiogruppe: Leertaste/Enter waehlt, Pfeiltasten wechseln. */
      o.addEventListener("keydown", function (e) {
        var ziel = null;
        if (e.key === " " || e.key === "Enter") ziel = o;
        else if (e.key === "ArrowRight" || e.key === "ArrowDown") ziel = optionen[(i + 1) % optionen.length];
        else if (e.key === "ArrowLeft" || e.key === "ArrowUp") ziel = optionen[(i - 1 + optionen.length) % optionen.length];
        if (!ziel) return;
        e.preventDefault();
        waehlen(ziel);
        ziel.focus();
      });
    });
  }

  function lichtkegel(hero) {
    if (!window.matchMedia || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    var laeuft = false, x = 0, y = 0;
    hero.addEventListener("pointermove", function (e) {
      var r = hero.getBoundingClientRect();
      x = ((e.clientX - r.left) / r.width) * 100;
      y = ((e.clientY - r.top) / r.height) * 100;
      if (laeuft) return;
      laeuft = true;
      requestAnimationFrame(function () {
        hero.style.setProperty("--mx", x + "%");
        hero.style.setProperty("--my", y + "%");
        laeuft = false;
      });
    });
  }

  /* Der Hero-Film laedt erst, wenn die Seite fertig ist. Das Standbild bleibt
     damit das groesste sichtbare Element und der LCP haengt nicht am Video.
     Wer Bewegung reduziert hat oder im Datensparmodus ist, bekommt nur das Bild. */
  function herofilm(feld) {
    var quelle = feld.dataset.dqHerofilm;
    if (!quelle) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var v = navigator.connection;
    if (v && (v.saveData || /2g/.test(v.effectiveType || ""))) return;

    function laden() {
      var standbild = feld.querySelector("img:not(.dq-hero__produkt)");
      var film = document.createElement("video");
      film.src = quelle;
      /* Das Standbild als poster: so zeigt der Film nie eine schwarze Flaeche,
         auch nicht in einem Hintergrund-Tab, in dem er nicht weiterlaeuft. */
      if (standbild) film.poster = standbild.currentSrc || standbild.src;
      film.muted = true;
      film.loop = true;
      film.playsInline = true;
      film.autoplay = true;
      film.preload = "auto";
      film.setAttribute("aria-hidden", "true");
      film.tabIndex = -1;
      film.dataset.dqAn = "true";
      feld.insertBefore(film, feld.firstChild);
      var p = film.play();
      if (p && p.catch) p.catch(function () { film.remove(); });
    }

    function gleich() {
      if (window.requestIdleCallback) requestIdleCallback(laden, { timeout: 2500 });
      else setTimeout(laden, 600);
    }

    if (document.readyState === "complete") gleich();
    else window.addEventListener("load", gleich, { once: true });
  }

  /* Kopfzeile verdichten, sobald der Hero durch ist. Ein Beobachter,
     kein Scroll-Handler — das kostet nichts pro Bild. */
  function kopfzeile() {
    var kopf = document.querySelector(".dq-kopf");
    var marke = document.querySelector("[data-dq-leiste-marke]");
    if (!kopf || !marke || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (e) {
      kopf.dataset.dqEng = e[0].isIntersecting ? "false" : "true";
    }, { threshold: 0 }).observe(marke);
  }

  /* Der Nörgler: bei jedem Aufruf eine andere Zeile, danach auf Knopfdruck
     die naechste. Die Reihenfolge wird einmal gemischt, damit sich nichts
     wiederholt, bevor alle durch sind. */
  function noergler(wurzel) {
    var zeilen = lies("dq-noergler");
    if (!zeilen || !zeilen.length) return;
    var textEl = wurzel.querySelector("[data-dq-noergler-text]");
    var blase = wurzel.querySelector("[data-dq-noergler]");
    var knopf = wurzel.querySelector("[data-dq-noergler-neu]");
    var anzahlEl = wurzel.querySelector("[data-dq-noergler-anzahl]");
    if (anzahlEl) anzahlEl.textContent = zeilen.length;

    var reihe = zeilen.slice();
    for (var i = reihe.length - 1; i > 0; i--) {
      var k = zufall(i + 1), t = reihe[i];
      reihe[i] = reihe[k]; reihe[k] = t;
    }
    var pos = 0;

    function zeigen() {
      if (pos >= reihe.length) pos = 0;
      textEl.textContent = reihe[pos++];
      blase.dataset.dqWechsel = "false";
      void blase.offsetWidth;
      blase.dataset.dqWechsel = "true";
    }

    zeigen();
    if (knopf) knopf.addEventListener("click", zeigen);
  }

  function start() {
    kopfzeile();
    var ng = document.querySelector(".dq-noergler");
    if (ng) noergler(ng);
    var sp = document.querySelector("[data-dq-spiel]");
    if (sp) lichtkegel(sp);
    var hf = document.querySelector("[data-dq-herofilm]");
    if (hf) herofilm(hf);
    var h = document.querySelector("[data-dq-licht]");
    if (h) lichtkegel(h);
    var z = document.querySelector("[data-dq-spiel]");
    if (z) kartenzieher(z);
    Array.prototype.forEach.call(document.querySelectorAll("[data-dq-video]"), videofassade);
    var l = document.querySelector("[data-dq-leiste]");
    if (l) kaufleiste(l);
    var lenaFuerBlick = document.querySelector("[data-dq-lena]");
    if (lenaFuerBlick) lenaBlick(lenaFuerBlick);
    var t = document.querySelector("[data-dq-ton]");
    if (t) {
      /* Ton gehoert zum Kartenzieher - Musik laeuft nur waehrend einer Runde.
         Als schwebender Knopf verdeckte er auf dem Handy den Preis auf der
         Produktseite und die Pakt-Knoepfe. Deshalb steht er direkt ueber dem
         Spieltisch, sichtbar und ohne etwas zu ueberdecken. */
      var tisch = z && z.querySelector(".dq-tisch");
      if (tisch) {
        tisch.parentNode.insertBefore(t, tisch);
        t.classList.add("dq-ton--imspiel");
      }
      tonschalter(t);
    }
    var m = document.querySelector("[data-dq-mengen]");
    if (m) mengenwahl(m);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
